import { PageProps } from 'gatsby';
import { ReactNode } from 'react';
import { Header } from '@opswat/ui';
import { PageHeader } from 'components/layout/PageHeader';
import { ArchiveMenu } from 'components/ArchiveMenu';
import { Logo } from 'components/layout/Logo';

type ArchiveLayoutProps = Omit<PageProps, 'children'> & { children?: ReactNode };

export const ArchiveLayout = ({ children }: ArchiveLayoutProps) => {
    return (
        <div className='tw:font-roboto tw:flex tw:flex-col tw:h-screen' data-testid='archive-layout-root'>
            <Header>
                <Header.Collapse disabled />
                <Logo />
                <Header.Actions>
                    <PageHeader />
                </Header.Actions>
            </Header>
            <div className='tw:flex tw:overflow-hidden tw:h-full'>
                <ArchiveMenu />
                <main className='tw:p-20 tw:bg-neutrals-100 tw:dark:bg-neutrals-1200 tw:flex-1 tw:h-full tw:overflow-y-auto tw:border-l tw:border-neutrals-200 tw:dark:border-neutrals-1000'>
                    {children}
                </main>
            </div>
        </div>
    );
};
